import { DONATION_ROUTES } from '@/constants';

import { isKbWebview, nativeCall } from './nativeCall';

export const moveBackInfo = (
  /** 파라미터를 제외한 전체 URL */
  url: string,
  /** 파라미터 정보 Object */
  searchParams: { [key: string]: string },
  /** 스택 사용 여부 */
  useYN: 'Y' | 'N' = 'Y',
  /** 성공 콜백 함수 이름 (우리쪽 함수) */
  successCallbackFnName?: string,
  replace?: boolean,
) => {
  const move = () => {
    nativeCall(
      'addHistoryStack',
      successCallbackFnName ?? 'setTopMenuV2',
      '',
      JSON.stringify({
        url,
        params: searchParams,
        useYN, //스택사용 여부
      }),
    );
  };

  if (replace) {
    const callbackName = `moveBackInfoReplace_${Date.now()}`;
    (window as typeof window & { [key: string]: () => void })[callbackName] =
      () => {
        delete (window as typeof window & { [key: string]: () => void })[
          callbackName
        ];
        move();
      };

    nativeCall(
      'removeHistoryStack',
      callbackName,
      '',
      JSON.stringify({ cnt: 1 }),
    );

    return;
  }

  move();
};

const addHistoryStackThisDonationHome = () => {
  nativeCall(
    'addHistoryStack',
    '',
    '',
    JSON.stringify({
      url: new URL(DONATION_ROUTES.HOME.pathname, location.origin).toString(),
      params: {},
      useYN: 'Y',
    }),
  );
};

if (typeof window !== 'undefined' && isKbWebview()) {
  (
    window as typeof window & {
      addHistoryStackThisDonationHome: typeof addHistoryStackThisDonationHome;
    }
  ).addHistoryStackThisDonationHome = addHistoryStackThisDonationHome;
}
